export default "__VITE_ASSET__e8e315f2__"